import Request from '@/utils/request';

class Product extends Request {
  // 获取分类
  fetchCategories(data) {
    return this.post('/category/list', data);
  }

  // 获取首页推荐分类和商品
  fetchRecommends(data) {
    return this.post('/index/recommend', data);
  }

  // 获取商品列表
  fetchProducts(data) {
    return this.post('/goods_spu/list', data);
  }

  // 获取抢购列表
  fetchFlashSeals(data) {
    return this.post('/flash_sale/list', data);
  }

  // 获取商品详情
  fetchProduct(data) {
    return this.post('/goods_spu/get', data);
  }

  // 获取评论列表
  fetchComments(data) {
    return this.post('/order_comment/list', data);
  }

  // 添加购物车
  addProductToShoppingCart(data) {
    return this.post('/cart/add', data);
  }

  // 获取购物车商品列表
  fetchShoppingCartProducts(data) {
    return this.post('/cart/list', data);
  }

  // 更新购物车信息
  updateShoppingCartProducts(data) {
    return this.post('/cart/renew', data);
  }

  // 获取用户搜索历史关键字
  fetchHistorySearchKeywords(data) {
    return this.post('/user_keyword/list', data);
  }

  // 获取平台热门搜索关键词
  fetchPopularSearchKeywords(data) {
    return this.post('/keyword/list', data);
  }

  // 搜索商品
  fetchProductsByKeyword(data) {
    return this.post('/goods_spu/search', data);
  }

  // 获取广告
  fetchAds(data) {
    return this.post('/ad/get', data);
  }
}

export default new Product();
